import { Building2, Contact } from 'lucide-react';
import type { CriacaoWeb, PropsCriacao } from '../../nucleo/modulos-web';
import { FormContato, FormEmpresa } from './CrmFormularios';

/**
 * Ajustes do CRM 27/10 (C6, K2, C8): empresa e contato no botão flutuante e no menu "Criar" da casca nova, e no "Adicionar
 * empresa/contato" do formulário de negociação (que recebe o cadastro criado por `aoCriar`). O contato nasce na empresa da
 * página, quando há.
 */
function CriarEmpresa({ aoFechar, aoCriar }: PropsCriacao) {
  return <FormEmpresa aberto aoFechar={aoFechar} aoSalvar={(id) => aoCriar?.({ id })} criarOutra={!aoCriar} />;
}

function CriarContato({ aoFechar, contexto, aoCriar }: PropsCriacao) {
  return <FormContato aberto aoFechar={aoFechar} empresa={contexto.empresa} aoSalvar={(id) => aoCriar?.({ id })} criarOutra={!aoCriar} />;
}

export const criacoesCadastros: CriacaoWeb[] = [
  { chave: 'contato', rotulo: 'criacao.itens.contato', icone: Contact, permissao: 'cadastros.criar', subsistemas: ['crm'], posicao: 40, componente: CriarContato },
  { chave: 'empresa', rotulo: 'criacao.itens.empresa', icone: Building2, permissao: 'cadastros.criar', subsistemas: ['crm'], posicao: 30, componente: CriarEmpresa },
];
